module.exports = __webpack_public_path__ + "img/logo_华唯.2ada2e31.png";